import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { OrganizationListInitialState, OrganizationListLoad } from './organization-list.actions';
import { OrganizationListState, OrganizationListStateModel } from './organization-list.state';
import { OrganizationListSearchCriteria } from '../models';

@Injectable({ providedIn: 'root' })
export class OrganizationListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<OrganizationListStateModel> = this.store.select(OrganizationListState.getState);
  loaded$: Observable<boolean> = this.store.select(OrganizationListState.getLoaded);

  constructor(private store: Store) {}

  loadAll(searchCriteria: OrganizationListSearchCriteria): void {
    this.store.dispatch(new OrganizationListLoad(searchCriteria));
  }

  setInitialState(): void {
    this.store.dispatch(new OrganizationListInitialState());
  }
}
